import { LBBadge } from '@linearb/buzz'

interface LicenseTypeBadgeProps {
  value?: string | null
}

export const LicenseTypeBadge: React.FC<LicenseTypeBadgeProps> = ({
  value
}) => {
  if (!value) {
    return null
  }
  return (
    <LBBadge variant='outline' className='text-sm'>
      {value}
    </LBBadge>
  )
}

interface LicensePlanBadgeProps {
  value?: string | null
}

export const LicensePlanBadge: React.FC<LicensePlanBadgeProps> = ({
  value
}) => {
  if (!value) {
    return null
  }
  return (
    <LBBadge variant='secondary' className='text-sm min-w-[5.5rem] justify-center'>
      {value}
    </LBBadge>
  )
}
